<template>
	<div id="sre-ability">
		<h2>维图能为您提供什么</h2>
		<p>提供混合云资源统一纳管、监控、运维，为您的多云生产环境降本增效。</p>
		<ul>
			<li v-for="item in data" :key="item.id">
				<div class="item" :class="{'active':active==item.id+1}">
					<h4>{{item.title}}</h4>
					<p v-for="(content,index) in item.contents" :key="index">{{content}}</p>
				</div>
				<!-- <div class="decoration"> -->
				<i class="iconfont shadow" :class="item.iconUrl" />
				<i class="iconfont" :class="item.iconUrl" />
				<!-- </div> -->
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'SreAbility',
		data() {
			return {
				active: 0,
				data: [{
						id: 0,
						title: '专业的技术团队',
						iconUrl: 'icon-zhuanyetuandui',
						contents: ['拥有专业的云计算解决方案服务团队', '在多个金融科技、 能源制造企业落地实施， 深受好评 ', '连通多云资源， 释放混合云能力']
					}, {
						id: 1,
						title: '混合云资源统一监管',
						iconUrl: 'icon-jianguan',
						contents: ['提供异构资源的统一纳管 ', '通过自动化、 自服务提供更多更丰富的云治理手段 ', '有效监管云成本开支， 提高资源利用率']
					},
					{
						id: 2,
						title: '降低管理负责度，提升效率',
						iconUrl: 'icon-xiaoshuaijiankongpingtai',
						contents: ['降低异构资源管理复杂度， 提高运维能力水平 ', 'IT部门自服务快速获取资源， 提高效率 ', '可视化编排自动化工具， 预置集成丰富运维管理工具 ']
					}
				]
			}
		},
		methods: {
			activeMe(index) {
				this.active = index
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		#sre-ability {
			width: 100%;
			height: 492px;
			background-color: #F1F7FF;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-ability h2 {
			font-size: 36px;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 79px;
		}

		#sre-ability p {
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 37px 0 60px;
		}

		#sre-ability ul {
			display: flex;
			justify-content: space-between;
			width: 75%;
			height: 180px;
		}

		#sre-ability ul li {
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 32.5%;
			height: 100%;
			border-radius: 5px;
		}

		#sre-ability ul li .item:hover {
			background: rgba(242, 249, 255, 1);
			box-shadow: 5px 5px 5px 0px rgba(221, 233, 245, 1);
		}

		#sre-ability ul li .item {
			width: 100%;
			height: 155px;
			margin-top: 30px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-content: flex-start;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-ability ul li .decoration {
			/* position: absolute; */
		}

		#sre-ability ul li i {
			display: block;
			margin: 40px 0 7px;
			font-size: 55px;
			background: linear-gradient(0deg, rgba(3, 208, 217, 1), rgba(0, 244, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			position: absolute;
			left: 18px;
			top: -35px;
		}

		#sre-ability ul li i.shadow {
			background: linear-gradient(180deg, rgba(0, 235, 246, 1), rgba(255, 255, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			opacity: 0.3;
			left: 11px;
			top: -40px;
		}

		#sre-ability ul li .item h4 {
			text-align: left;
			font-size: 18px;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin: 26px 0 10px 91px;
		}

		#sre-ability ul li .item p {
			font-size: 14px;
			font-family: SimSun;
			font-weight: 400;
			color: #818181;
			text-align: left;
			line-height: 2;
			margin: 0 0 0 91px;
		}
	}

	@media(max-width:992px) {
		#sre-ability {
			width: 100%;
			background-color: #F1F7FF;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-ability h2 {
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 35px;
		}

		#sre-ability p {
			font-size: 0.12rem;
			width: 75%;
			line-height: 1.1;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 0.37rem 0 0.6rem;
		}

		#sre-ability ul {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			width: 100%;
		}

		#sre-ability ul li {
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 90%;
			border-radius: 5px;
			margin-bottom: 10px;
		}

		#sre-ability ul li .item.active {
			background: rgba(242, 249, 255, 1);
			box-shadow: 5px 5px 5px 0px rgba(221, 233, 245, 1);
		}

		#sre-ability ul li .item {
			width: 100%;
			margin-top: 0.1rem;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-content: flex-start;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-ability ul li .decoration {
			/* position: absolute; */
		}

		#sre-ability ul li i {
			display: block;
			margin: 0.4rem 0 0.07rem;
			font-size: 0.35rem;
			background: linear-gradient(0deg, rgba(3, 208, 217, 1), rgba(0, 244, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			position: absolute;
			left: 28px;
			top: 13px;
		}

		#sre-ability ul li i.shadow {
			background: linear-gradient(180deg, rgba(0, 235, 246, 1), rgba(255, 255, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			opacity: 0.3;
			left: 24px;
			top: 10px;
		}

		#sre-ability ul li .item h4 {
			text-align: left;
			font-size: 0.14rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin: 0.2rem 0 0.1rem 80px;
		}

		#sre-ability ul li .item p {
			font-size: 0.12rem;
			font-family: SimSun;
			font-weight: 400;
			color: #818181;
			text-align: left;
			line-height: 1.1;
			margin: 0 0 0.1rem 80px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreAbility.vue